module.exports = __webpack_public_path__ + "static/media/not-yet-checked-in.c6a00673.svg";